import Cookies from "js-cookie"

import { isGID } from "@unlikelystudio/commerce-connector"

import { geti18nLocale } from "~/lib/i18n/utils/get-processed-locale"
import type { CookieProps, TDB } from "~/providers/RecentlyViewedProvider/utils/types"

export function getRecentlyViewedProducts(ctx: CookieProps) {
  const { cookieKey = "" } = ctx
  const cookie = Cookies.get(cookieKey)

  return (cookie ? JSON.parse(cookie) : {}) as TDB
}

export function getRecentlyViewedProductsFromLocale(locale: string, ctx: CookieProps) {
  const i18nLocale = geti18nLocale(locale)
  return getRecentlyViewedProducts(ctx)[i18nLocale]?.filter((n) => isGID(n?.id)) ?? []
}
